import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints } from 'styles/style-constants';

import { SectionCard } from './AssetRegistryVotingPage.layout';

export const MobileSidebar = styled(SectionCard)`
    display: none;
    ${respondDown(Breakpoints.md)`display: block;`}
`;
